import { Link, Tooltip } from "@mui/material"
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded"

// Masterschool's HubSpot portal. A routed lead's id is the campus user's client
// id, not a HubSpot contact id, so the console links to the contact by email
// search (the same URL shape campus's own tools use) rather than a record id.
const HUBSPOT_PORTAL_ID = "9484219"

export function hubspotContactSearchUrl(email: string): string {
  return `https://app.hubspot.com/contacts/${HUBSPOT_PORTAL_ID}/objects/0-1/views/all/list?query=${encodeURIComponent(
    email,
  )}`
}

// One consistent "find this lead in HubSpot" affordance for every surface that
// lists routed leads. Renders nothing when the email is missing, so a row we
// could not resolve simply has no link rather than a dead one.
export function HubSpotLink(props: { email: string | null | undefined }) {
  if (!props.email) {
    return null
  }
  return (
    <Tooltip title="Find this lead in HubSpot">
      <Link
        href={hubspotContactSearchUrl(props.email)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          color: "text.secondary",
          "&:hover": { color: "primary.main" },
        }}
        aria-label="Find this lead in HubSpot"
      >
        <OpenInNewRoundedIcon sx={{ fontSize: 16 }} />
      </Link>
    </Tooltip>
  )
}
